// extracted by mini-css-extract-plugin
module.exports = {"privacyContainer":"privacy_privacyContainer__ZSn9e","hide":"privacy_hide__Akwy8"};